import { PlannerBase }   from "../orders/planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
class Title extends PlannerBase {
  jobnos: Array<any> = [];
  status: Array<any> = [];
  orderType: Array<any> = [];
  phaseId: Array<any> = [];
  init(){
    super.init();
    this.watch();
    this.setProps(this.opts)
  }
  onChangeStore(a, b, c){
    this.setProps(a);
    super.onChangeStore(a, b, c);
  }
  setProps(opts){
    let inputs = opts.inputs
    this.setPropsJobnos(inputs);
    this.setPropsStatus(inputs);
    this.setPropsOrderTypes(inputs);
    this.setPropsPhases(inputs);
  }
  setPropsMultiple(inputsProp){
    if(inputsProp.value == '' || inputsProp.value == null) { return []; }
    let prop = [];
    let ids = inputsProp.value.split(',');
    for(let i=0; i<inputsProp.items.length; i++){
      let item = inputsProp.items[i];
      if(ids.includes(item.value.toString())){
        prop.push(item);
      }
    }
    return prop
  }
  setPropsJobnos(inputs){
    this.jobnos = inputs.order_ids.items.map(item => item.job_no)
  }
  setPropsStatus(inputs){
    this.status = this.setPropsMultiple(inputs.status);
  }
  setPropsOrderTypes(inputs){
    this.orderType = this.setPropsMultiple(inputs.order_type);
  }
  setPropsPhases(inputs){
    this.phaseId = this.setPropsMultiple(inputs.phase_id);
  }
}
riot.mixin('planner.title', Title as riot.TagMixin)
